/**
 * classNames evaluates a list of classes passed
 * in as single arguments to return a single string
 *
 * @description Some of the input strings can be conditionals
 * which are resolved to on of its true or false strings
 *
 * @example
 * <div className={classNames(`mt-2 ...`, user != null ? 'bg-green-200':'bg-red-200')} />
 *
 * @param classes string[]
 * @returns string
 */
export default function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}
